import { collection, onSnapshot, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../firebase';

const AttendanceDetails = () => {
const [attendanceDetails,setAttendanceDetails] = useState([]);
const [standard,setStandard] = useState("");
const [classSection,setClassSection] = useState("");
const [viewAll,setViewAll] = useState(false);

useEffect(()=>{
    const q = query(collection(db, "attendanceLists"));
    onSnapshot(q, (querySnapshot) => {
      let attendanceArray = [];
      querySnapshot.forEach((doc) => {
        attendanceArray.push({id:doc.id,...doc.data()});
      });
      setAttendanceDetails(attendanceArray);
    });
},[])

let tempArr=[]
tempArr=(attendanceDetails?.filter((item) => item?.standard === standard && item?.classSection === classSection));

// let attendanceReport=[]
// attendanceReport=(attendanceDetails?.filter((item) => item?.present === present && item?.absent === absent));




const buttonHandle = () => {
  setViewAll((viewAll) => viewAll = !viewAll )
}

  return (
    <div className="p-5  min-h-screen">
        <div className="grid grid-cols-2  pl-5 pr-5 ">
    <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Class
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select
                       value={standard}
                       onChange={(e) => {
                      setStandard(e.target.value);
                               }}
                   className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                       >
                         <option value="null"> select</option>
                      <option value="1">Class I</option>
                      <option value="2">Class II</option>
                      <option value="3">Class III</option>
                      <option value="4">Class IV</option>
                      <option value="5">Class V</option>
                      <option value="6">Class VI</option>
                      <option value="7">Class VII</option>
                      <option value="8">Class VIII</option>
                      <option value="9">Class IX</option>
                      <option value="10">Class X</option>
                      <option value="11">Class XI</option>
                      <option value="12">Class XII</option>
                  </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/4">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Section
                    </label>
                    </div>
                    <div className="md:w-1/2">
                   <select
                   value={classSection}
                   onChange={(e) => {
                  setClassSection(e.target.value);
                           }}
              className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="null"> select</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                      <option value="F">F</option>
                    </select></div></div></div>
                    {/* <div className="w-full mb-6">
                  <div className="md:w-full text-center">
                  <button className="text-white bg-yellow-600 py-1 px-1 rounded-md w-32 ml-20 " 
                  onClick={buttonHandle}
                  >View All</button>
                  </div>
                 
                  </div> */}
            </div> 
            
        <div className='font-medium text-2xl bg-[#033f63] w-full py-2 text-center text-white'>{standard} / {classSection}</div>
           <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
            <th className="py-3 "> Sl No.</th>
            <th className="py-3 ">present</th>
            <th className="py-3 ">absent</th>
            <th className="py-3 ">date</th>
          </tr>
        </thead>
              <tbody>
          {tempArr?.map((item,index)=>(<tr key={index} className="border-b">
       <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">{++index}</td>
      <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
          <th className="py-3 ">SI. No.</th>
            <th className="py-3 ">Roll No.</th>
            <th className="py-3 ">Full Name</th>
          </tr>
        </thead>
       <tbody>
        {item?.present.sort((a, b) => a.studentRollNumber - b.studentRollNumber).map((elem,ind)=>(<tr key={ind}><td>{++ind}</td><td>{elem.studentRollNumber}</td><td>{elem.fullName}</td></tr>))}
        </tbody>
        </table>
        </td>

      <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
          <th className="py-3 ">SI. No.</th>
            <th className="py-3 ">Roll No.</th>
            <th className="py-3 ">Full Name</th>
          </tr>
        </thead>
       <tbody>
        {item?.absent.sort((a, b) => a.studentRollNumber - b.studentRollNumber).map((elem,ind)=>(<tr key={ind}><td>{++ind}</td><td>{elem.studentRollNumber}</td><td>{elem.fullName}</td></tr>))}
        </tbody>
        </table>
        </td>

       <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
        {item.date.toDate().toLocaleString('en-In')}</td>
        </tr>)) }
          </tbody>
          
      {/* {viewAll && (
        <tbody>
          {attendanceDetails?.map((item,index)=>(<tr key={index} className="border-b">

          <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">{++index}</td>
      <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
          <th className="py-3 ">SI. No.</th>
            <th className="py-3 ">Roll No.</th>
            <th className="py-3 ">Full Name</th>
          </tr>
        </thead>
       <tbody>
        {item?.present?.map((elem,ind)=>(<tr key={ind}><td>{++ind}</td><td>{elem.studentRollNumber}</td><td>{elem.fullName}</td></tr>))}
        </tbody>
        </table>
        </td>

      <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
      <table className="w-full  text-center">
        <thead className="border-b  ">
          <tr className="bg-gray-100">
          <th className="py-3 ">SI. No.</th>
            <th className="py-3 ">Roll No.</th>
            <th className="py-3 ">Full Name</th>
          </tr>
        </thead>
       <tbody>
        {item?.absent?.map((elem,ind)=>(<tr key={ind}><td>{++ind}</td><td>{elem.studentRollNumber}</td><td>{elem.fullName}</td></tr>))}
        </tbody>
        </table>
        </td>

       <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
        {item.date.toDate().toLocaleString('en-In')}</td>
        </tr>)) }
          </tbody>
        )} */}
      </table>
    </div>
  )
}

export default AttendanceDetails 